<template>
  <!-- 关于我们 -->
  <section class="container">
    <Header></Header>
    <div class="wrapper">
      <div class="locationM text-left">
        <Breadcrumb>
          <img class="img" src="../assets/location.png" alt />
          当前位置：
          <BreadcrumbItem to="/">首页</BreadcrumbItem>
          <BreadcrumbItem>关于我们</BreadcrumbItem>
        </Breadcrumb>
      </div>
      <div class="innerM">
        <div class="title">关于我们</div>
        <div class="button" v-show="status==0">
          <Button type="success" @click="openComplaintModal">点击投诉</Button>
        </div>
        <div class="inner-wrapper" v-html="content"></div>
      </div>
      <Modal v-model="complaintModal">
        <!-- :mask-closable="false" -->
        <div slot="header">亲爱的学员，欢迎您对此次培训提出宝贵意见，我们将对你的意见和建议作出及时调查处理，感谢你对我们工作的支持，谢谢！</div>
        <div class="model-header">
          <!-- <el-form :model="complaintList" label-width="80px">
            <el-form-item label="时间">
              <el-date-picker type="date" placeholder="选择日期" v-model="complaintList.time"></el-date-picker>
            </el-form-item>
            <el-form-item label="建议">
              <el-input v-model="complaintList.idea" type="textarea"></el-input>
            </el-form-item>
            <el-form-item label="结果">
              <el-input v-model="complaintList.suggest" type="textarea"></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="complaintList.remarks" type="textarea"></el-input>
            </el-form-item>
          </el-form>-->
          <table class="table" width="100%" border="1" cellspacing="0" cellpadding="0">
            <tr>
              <td colspan="4">满意度调查</td>
              <!-- <td width="181">网址</td>
              <td width="112">说明</td>
              <td width="112">说明</td>-->
            </tr>
            <tr>
              <td style="border-top:0;border-right:0">满意度</td>
              <td style="border-top:0;border-right:0">满意</td>
              <td style="border-top:0;border-right:0">基本满意</td>
              <td style="border-top:0">不满意</td>
            </tr>
            <tr>
              <td style="border-top:0;border-right:0">讲师授课水平</td>
              <td style="border-top:0;border-right:0" @click="chacked1">
                <el-checkbox v-model="teachChecked1"></el-checkbox>
              </td>
              <td style="border-top:0;border-right:0" @click="chacked2">
                <el-checkbox v-model="teachChecked2"></el-checkbox>
              </td>
              <td style="border-top:0" @click="chacked3">
                <el-checkbox v-model="teachChecked3"></el-checkbox>
              </td>
            </tr>
            <tr>
              <td style="border-top:0;border-right:0">平台学习情况</td>
              <td style="border-top:0;border-right:0" @click="learn1">
                <el-checkbox v-model="learnChecked1"></el-checkbox>
              </td>
              <td style="border-top:0;border-right:0" @click="learn2">
                <el-checkbox v-model="learnChecked2"></el-checkbox>
              </td>
              <td style="border-top:0" @click="learn3">
                <el-checkbox v-model="learnChecked3"></el-checkbox>
              </td>
            </tr>
            <tr>
              <td style="border-top:0;border-right:0;height:120px">意见或建议</td>
              <td colspan="3" style="border-top:0;height:120px;">
                <el-input
                  v-model="complaintList.idea"
                  :rows="5"
                  type="textarea"
                  placeholder="请填写您的意见"
                ></el-input>
              </td>
            </tr>
          </table>
        </div>
        <div slot="footer">
          <Button type="text" @click="complaintModal = false">取消</Button>
          <Button type="success" @click="confirmModal">确认</Button>
        </div>
      </Modal>
    </div>
    <Footer></Footer>
  </section>
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer";
const complaintData = {
  idea: "", //意见
  teachChecked: "", //授课满意度
  learnChecked: "", //学习满意度
  userId: "" //用户id
};
export default {
  name: "Contact",
  data() {
    return {
      content: "",
      complaintModal: false, //投诉框是否显示
      status: 0, //是否显示投诉按钮
      complaintList: Object.assign({}, complaintData), //投诉框内容
      teachChecked1: false, //授课满意
      teachChecked2: false, //授课基本满意
      teachChecked3: false, //授课不满意
      learnChecked1: false, //学习满意
      learnChecked2: false, //学习基本满意
      learnChecked3: false //学习不满意
    };
  },
  mounted() {
    this.getInstance();
    this.setTab();
  },
  methods: {
    chacked2() {
      this.teachChecked1 = false;
      this.teachChecked3 = false;
      this.complaintList.teachChecked = "";
      if (!this.teachChecked2) {
        this.teachChecked1 = false;
        this.teachChecked3 = false;
        this.complaintList.teachChecked = "1";
      }
    },
    chacked3() {
      this.teachChecked1 = false;
      this.teachChecked2 = false;
      this.complaintList.teachChecked = "";
      if (!this.teachChecked3) {
        this.teachChecked2 = false;
        this.teachChecked1 = false;
        this.complaintList.teachChecked = "2";
      }
    },
    chacked1() {
      this.teachChecked2 = false;
      this.teachChecked3 = false;
      this.complaintList.teachChecked = "";
      if (!this.teachChecked1) {
        this.teachChecked2 = false;
        this.teachChecked3 = false;
        this.complaintList.teachChecked = "0";
      }
    },
    learn1() {
      this.learnChecked2 = false;
      this.learnChecked3 = false;
      this.complaintList.learnChecked = "";
      if (!this.learnChecked1) {
        this.learnChecked2 = false;
        this.learnChecked3 = false;
        this.complaintList.learnChecked = "0";
      }
    },
    learn2() {
      this.learnChecked1 = false;
      this.learnChecked3 = false;
      this.complaintList.learnChecked = "";
      if (!this.learnChecked2) {
        this.learnChecked1 = false;
        this.learnChecked3 = false;
        this.complaintList.learnChecked = "1";
      }
    },
    learn3() {
      this.learnChecked2 = false;
      this.learnChecked1 = false;
      this.complaintList.learnChecked = "";
      if (!this.learnChecked3) {
        this.learnChecked2 = false;
        this.learnChecked1 = false;
        this.complaintList.learnChecked = "2";
      }
    },
    //打开投诉框
    openComplaintModal() {
      this.complaintModal = true;
    },
    confirmModal() {
      var that = this;
      that.complaintList.userId = this.$store.state.user.idCard;
      if (!that.complaintList.teachChecked) {
        return that.$Message.warning("请至少选择一条授课满意度！！！");
      }
      if (!that.complaintList.learnChecked) {
        return that.$Message.warning("请至少选择一条学习满意度！！！");
      }
      if (that.complaintList.userId == undefined) {
        return that.$Message.warning("请确认您已登录！！！");
      }

      var data = that.complaintList;
      this.$http({
        url: that.webhost + "guide/sendEmail",
        method: "POST",
        data: data
      }).then(({ data }) => {
        console.log(data);

        if (data && data.code === 0) {
          that.$Message.success("投诉成功");
          that.complaintList = Object.assign({}, complaintData);
          that.complaintModal = false;
          that.teachChecked1 = false;
          that.teachChecked2 = false;
          that.teachChecked3 = false;
          that.learnChecked1 = false;
          that.learnChecked2 = false;
          that.learnChecked3 = false;
        } else {
          that.$Message.warning(data.msg);
        }
      });
    },
    getInstance() {
      var that = this;
      //   this.$http({
      //     url: that.webhost + "guide/getContent/3",
      //     method: "GET"
      //   }).then(({ data }) => {
      //     if (data && data.code === 0) {
      //       that.content = data.data;
      //     }
      //   });
      this.$http({
        url: that.webhost + "guide/getLxwm",
        method: "GET"
      }).then(({ data }) => {
        if (data && data.code === 0) {
          that.content = data.data.guide.lxwm;
          console.log(data, 999);
          that.status = data.data.guide.status;
        }
      });
    }
  },
  components: {
    Header,
    Footer
  }
};
</script>

<style scoped>
.table {
  /* border: 1px solid #ccc; */
  text-align: center;
  border: 0;
}
tr {
  border: 0;
}
td {
  height: 40px;
  /* border: 0; */
  /* border-left: -1px solid #ccc; */
  /* border-top: -1px solid #ccc; */
  border: 1px solid #ccc;
}
.button {
  text-align-last: left;
  margin-left: 20px;
  margin-top: 20px;
}
.wrapper {
  width: 1200px;
  min-width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 90px;
  font-family: "PingFang SC";
}
.title {
  text-align: left;
  font-size: 25px;
  line-height: 72px;
  color: #000;
  border-bottom: solid 2px #ccc;
}
.locationM {
  height: 50px;
  line-height: 50px;
}
.locationM .ivu-breadcrumb {
  font-size: 15px;
  color: #000;
}
.locationM img {
  width: 23px;
  height: 22px;
  margin-right: 5px;
  position: relative;
  top: 3px;
}
.inner-wrapper {
  padding: 15px;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/Contact.vue